export var TabOptions;
(function (TabOptions) {
    TabOptions["INPUT"] = "input";
    TabOptions["ANNOTATE"] = "annotate";
})(TabOptions || (TabOptions = {}));
